module.exports = __webpack_public_path__ + "img/userRes_f.ac7a3fc5.png";